import { createAction, props } from "@ngrx/store";
import { PinsheetDates } from "../models/pinsheet-dates.model";

export const pinsheetDatesAction = createAction(
    '[Pinsheet Dates Details] retrieve pinsheet date details',props<{pinsheetDatesData:ReadonlyArray<PinsheetDates>}>(),
    
)